import IMenuItemBody from "../../../interfaces/IMenuItemBody";

export const SET_SELECTED_LIST = "SET_SELECTED_LIST";

export function setSelectedListId(taxItem: IMenuItemBody) {
    return {
        type: SET_SELECTED_LIST,
        payload: taxItem
    };
}
export const SET_MENU_ITEM_LIST = "SET_MENU_ITEM_LIST";

export function setItemList(itemList: any[]) {
    return {
        type: SET_MENU_ITEM_LIST,
        payload: itemList
    };
}

export const SET_FILTERS_STATE = "SET_FILTERS_STATE";

export function setFilterState(subcats: any) {
    return {
        type: SET_FILTERS_STATE,
        payload: subcats
    };
}

export const UPDATE_FILTER_STATE = "UPDATE_FILTER_STATE";

export function updateFilterState(subcats: any) {
    return {
        type: UPDATE_FILTER_STATE,
        payload: subcats
    };
}

export const REPLACE_SELECTED_LIST = "REPLACE_SELECTED_LIST";

export function replaceSelectedList(listItems: any[]) {
    return {
        type: REPLACE_SELECTED_LIST,
        payload: listItems
    };
}

export const SEARCH_TEXT = "SEARCH_TEXT";

export function setSearchText(searchText: String) {
    return {
        type: SEARCH_TEXT,
        payload: searchText
    };
}

export const SET_TAX_NAME = "SET_TAX_NAME";

export function setTaxName(taxName: string | null) {
    return {
        type: SET_TAX_NAME,
        payload: taxName
    }
}
